import styles from "./site.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import { toast } from "react-toastify";


export default function SiteMaintainence() {
  const { userToken } = useContext(UserContext);
  const [status, setStatus] = useState(true);

  const getMaintainenceStatus = useCallback(async () => {
    try {
      const res = await axios.get(
        `${apiConfig.getMaintainenceStatus}`,
      );
      setStatus(res?.data?.result || []);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getMaintainenceStatus();
  }, [getMaintainenceStatus, userToken]);

  const handleModeChange = async (id, status) => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      const body = {
        id:id, 
        status: status === false ? true : false
      }
      const res = await axios.post(
        `${apiConfig.updateMaintainence}`,
        body,
        { headers }
      );
      toast.success(res.data.responseMessage);
      setStatus(res?.data?.result || []);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Fees Management</h1>
      <div className={styles.gridContainer}>
        <div className={styles.topBox}>
          <div className={styles.dashboardContainer}>
            <p>{!status.status ? "Enable" : "Disable"} Site Maintainence</p>
            <div
              onClick={() => handleModeChange(status._id, status.status)}
              style={{
                display: 'inline-block',
                padding: '10px 20px',
                backgroundColor: !status.status ? 'green' : 'red',
                color: 'white',
                borderRadius: '20px',
                cursor: 'pointer',
                textAlign: 'center',
                fontSize: '16px',
              }}
            >
              {status.status ? 'Disable' : 'Enable'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

